import type { NetworkSource } from "@hq/client";

/** Connectivity from `navigator.onLine` plus the `online` / `offline` window events. */
export function browserNetworkSource(): NetworkSource {
  return {
    get online() {
      return typeof navigator === "undefined" ? true : navigator.onLine;
    },
    subscribe(listener) {
      const onOnline = () => listener(true);
      const onOffline = () => listener(false);
      window.addEventListener("online", onOnline);
      window.addEventListener("offline", onOffline);
      return () => {
        window.removeEventListener("online", onOnline);
        window.removeEventListener("offline", onOffline);
      };
    },
  };
}
